export default {"src":"/_next/static/media/warn.d93fdd99.svg","height":10,"width":9,"blurWidth":0,"blurHeight":0};